import './LeadReport.scss';
import React, {useEffect, useState} from 'react';
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../../Loader";
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {Legend} from "chart.js";
import {EmptyStarSVG, UserIcon, YellowStarSVG} from "../LeadManagwIcons/LeadManagwIcons";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";

const LeadReport = () => {

  const [isLoad, setIsLoad] = useState(false);
  const [initialData, setInitialData] = useState({});
  const [filterValue, setFilterValue] = useState("")

  const getInitialData = async () => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=reports&marketerId=" + filterValue)
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getInitialData()
  }, [filterValue]);

  return (
    <>
      {isLoad ?
        <div className={"lead-report"}>
          <div className={"detail-side"}>
            <div className={"grid-box"}>
              {initialData?.overallData?.map((item, index) => (
                <div key={"overall" + index} className={"current-box"}>
                  <span style={{background: "#FFD786"}}>{item?.group_caption}</span>
                  <div className={"value-box"}>{item?.group_count}</div>
                </div>
              ))}
            </div>
            <div className={"grid-box"}>
              <h5>گزارش نتیجه وضعیت</h5>
              {initialData?.status_results?.map((item, index) => (
                <div key={"overall" + index} className={"current-box"}>
                  <span style={{background: "#D1EBE7"}}>{item?.group_caption}</span>
                  <div className={"value-box"}>{item?.group_count + " --- " + item?.percentage_of_total + "%"}</div>
                </div>
              ))}
            </div>
            <div className={"grid-box"}>
              <h5>گزارش نتیجه تماس ها</h5>
              {initialData?.call_results?.map((item, index) => (
                <div key={"overall" + index} className={"current-box"}>
                  <span style={{background: `${item?.colorCode}`}}>{item?.group_caption}</span>
                  <div className={"value-box"}>{item?.group_count + " --- " + item?.percentage_of_total + "%"}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={"chart-side"}>
            {initialData?.isMarketer &&
              <div className={"user-information"}>
                <div className={"inline-element"}>
                  {initialData?.pictureUrl !== "" ? <img src={initialData?.pictureUrl} alt={"user"}/> : <UserIcon/>}
                  {initialData?.user}
                </div>
                <div className={"columns-element"}>
                  <div className={"inline-element"}>
                    امتیـاز شمـا :
                    {" " + initialData?.score}
                  </div>
                  <div className="star-rating">
                    {[...Array(5)].map((_, index) => {
                      if (index < Math.floor(initialData?.score)) {
                        return (
                          <YellowStarSVG/>
                        );
                      } else if (index < initialData?.score) {
                        return (
                          <YellowStarSVG/>
                        );
                      } else {
                        return (
                          <EmptyStarSVG/>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            }
            {initialData?.isManager &&
              <div className={"user-information"}>
                <DynaSelectBox options={initialData?.marketers}
                               hasFilter={true}
                               label={"انتخاب بازاریاب"}
                               className={"solid-dyna-input"}
                               value={filterValue}
                               onChange={(data) => setFilterValue(data?.value)}/>
              </div>
            }
            <div style={{width: '100%'}} className={"parent-chart"}>
              <h6>نمودار میزان فروش</h6>
              <ResponsiveContainer width="99%" height={350}>
                <BarChart
                  width={"100%"}
                  height={340}
                  data={initialData?.sellAmountChart}
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                  barSize={20}
                >
                  <XAxis dataKey="name" scale="point" padding={{left: 50, right: 10}}/>
                  <YAxis/>
                  <Tooltip/>
                  <Legend/>
                  <CartesianGrid strokeDasharray="3 3"/>
                  <Bar dataKey="uv" fill="#49B09D" background={{fill: '#eee'}}/>
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div style={{width: '100%'}} className={"parent-chart"}>
              <h6>نمودار تعداد فروش</h6>
              <ResponsiveContainer width="99%" height={350}>
                <BarChart
                  width={"100%"}
                  height={340}
                  data={initialData?.sellCountChart}
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                  barSize={20}
                >
                  <XAxis dataKey="name" scale="point" padding={{left: 50, right: 10}}/>
                  <YAxis/>
                  <Tooltip/>
                  <Legend/>
                  <CartesianGrid strokeDasharray="3 3"/>
                  <Bar dataKey="uv" fill="#F6683B" background={{fill: '#eee'}}/>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

        </div> : <Loader/>}
    </>
  );
};

export default LeadReport;